import {LoginUseCase} from '../../domain/auth/usecases/LoginUseCase';
import {LogoutUseCase} from '../../domain/auth/usecases/LogoutUseCase';
import {GetCurrentUserUseCase} from '../../domain/auth/usecases/GetCurrentUserUseCase';
import {Send2FACodeUseCase} from '../../domain/auth/usecases/Send2FACodeUseCase';
import {Verify2FACodeUseCase} from '../../domain/auth/usecases/Verify2FACodeUseCase';
import {
  User,
  UserCredentials,
  TwoFactorSendCodeRequest,
  TwoFactorSendCodeResponse,
  TwoFactorVerifyResponse,
} from '../../domain/auth/entities/User';

export class AuthService {
  constructor(
    private readonly loginUseCase: LoginUseCase,
    private readonly logoutUseCase: LogoutUseCase,
    private readonly getCurrentUserUseCase: GetCurrentUserUseCase,
    private readonly send2FACodeUseCase: Send2FACodeUseCase,
    private readonly verify2FACodeUseCase: Verify2FACodeUseCase,
  ) {}

  async login(credentials: UserCredentials): Promise<User> {
    return await this.loginUseCase.execute(credentials);
  }

  async logout(): Promise<void> {
    return await this.logoutUseCase.execute();
  }

  async getCurrentUser(): Promise<User | null> {
    return await this.getCurrentUserUseCase.execute();
  }

  async send2FACode(
    request: TwoFactorSendCodeRequest,
    token?: string,
  ): Promise<TwoFactorSendCodeResponse> {
    return await this.send2FACodeUseCase.execute(request, token);
  }

  async verify2FACode(
    code: string,
    token?: string,
  ): Promise<TwoFactorVerifyResponse> {
    return await this.verify2FACodeUseCase.execute(code, token);
  }
}

